<template>
  <svg width="24" height="18" viewBox="0 0 24 18">
    <g fill="#FFF" fill-rule="evenodd">
      <path d="M13.195 0H0v17.495h5.807v-5.408h6.933V7.175H5.807V5.042h7.388zM23.99 17.49V9.583h-7.756v7.907z"></path>
    </g>
  </svg>
</template>
